export const setMainProductPriceQuery = `mutation ($idProduct: Int!, $idPrice: Int!) {
    update_prodigio_prices(where: {id: {_neq: $idPrice}, products: {id_product: {_eq: $idProduct}}}, _set: {active: false}) {
      affected_rows
    }
  }`;
